import { z } from "zod";

export const ROLES = ["admin", "editor", "viewer"] as const;
export type Role = (typeof ROLES)[number];

// Zod schema for Role — used by the users schemas and any other validator that
// needs a parsed/validated role value (separate from the plain-type Role above).
export const RoleSchema = z.enum(["admin", "editor", "viewer"]);

// Document/asset classification, doubling as a user's read clearance.
// Umlaut spelling matches the existing assets.classification column.
export const CLEARANCES = ["öffentlich", "intern", "vertraulich"] as const;
export type Clearance = (typeof CLEARANCES)[number];
export const ClearanceSchema = z.enum(["öffentlich", "intern", "vertraulich"]);

const CLEARANCE_RANK: Record<Clearance, number> = {
  "öffentlich": 0,
  intern: 1,
  vertraulich: 2,
};

/** 0 = öffentlich, 1 = intern, 2 = vertraulich. Higher may read lower. */
export function clearanceRank(c: Clearance): number {
  return CLEARANCE_RANK[c];
}

/** Every classification a reader at this clearance may see. */
export function readableClassifications(c: Clearance): Clearance[] {
  const max = CLEARANCE_RANK[c];
  return CLEARANCES.filter((x) => CLEARANCE_RANK[x] <= max);
}
